<template>
  <div>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Invoice Settings
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    :items="companycodes.map(x=>x.toUpperCase())"
                    solo
                    :disabled="loading"
                    :loading="loading"
                    return-object
                    v-model="companysetting.code"
                    label="Company Code"
                    @change="loadCompanySettings"
                    item-text="name"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 v-if="companysetting.code">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        label="Facebook"
                        v-model="companysetting.facebook"
                        solo
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Whatsapp"
                        v-model="companysetting.whatsapp"
                        solo
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Instagram"
                        v-model="companysetting.instagram"
                        solo
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <vue-editor 
                        :config="config"
                        v-model="companysetting.toc"
                      ></vue-editor>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="updateSettings()">update</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import { VueEditor, Quill } from "vue2-editor";
import axios from 'axios';
export default {
  components:{ VueEditor },
  data(){
    return {
      config: {
        placeholder: '...',
      },
			loading: false,
      companycodes: [],
      selectedCode:null,
      companysetting:{},
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async loadCompanies(){
      this.loading = true
      let a = await db.ref('companies').once('value').then(x=>x.val().map(x=>x.toUpperCase()))
      this.loading = false
    },
    async updateSettings() {
      this.loading = true
      await db.ref(`settings/invoice/${this.companysetting.code.replace(' ', '').toUpperCase()}`).update(this.companysetting)
      this.loading = false
      this.companysetting.code = null
    },
    async loadCompanySettings(){
      let a = await db.ref(`settings/invoice/${this.companysetting.code.replace(' ', '').toUpperCase()}`).once('value').then(x=>x.val())
      this.companysetting = a?a:{code:this.companysetting.code}
    },
    async getCompanyCodes(){
      return new Promise(async(res, rej)=>{
        this.companycodes = await db.ref(`settings/dbfilters/companycodes`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
        res(true)
      }) 
		},
    
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
  },
  computed:{
    
  },
  async created(){
    this.loadCompanies()
    await this.getCompanyCodes()
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
